import { render, staticRenderFns } from "./ImproveLive.vue?vue&type=template&id=5730a9c6&scoped=true&"
import script from "./ImproveLive.vue?vue&type=script&lang=js&"
export * from "./ImproveLive.vue?vue&type=script&lang=js&"
import style0 from "./ImproveLive.vue?vue&type=style&index=0&id=5730a9c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5730a9c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
